import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { ConsultantFinderModalComponent } from './consultant-finder-modal/consultant-finder-modal.component';
import { ConsultantFinderPageComponent } from './consultant-finder-page/consultant-finder-page.component';
import { ConsultantFinderResultComponent } from './consultant-finder-result/consultant-finder-result.component';
import { ConsultantFinderComponent } from './consultant-finder/consultant-finder.component';
import { ConsultantLocatorPageComponent } from './consultant-locator-page/consultant-locator-page.component';
import { ConsultantRoutingModule } from './consultant-routing.module';
import { ConsultantWholesaleModalComponent } from './consultant-wholesale-modal/consultant-wholesale-modal.component';
import { ConsultantWidgetComponent } from './consultant-widget/consultant-widget.component';
import { MyOpenPartiesPagesComponent } from './my-open-parties-pages/my-open-parties-pages.component';
import { MyStoryBannerComponent } from './my-story-banner/my-story-banner.component';
import { MyStoryPageComponent } from './my-story-page/my-story-page.component';
import { ConsultantContactSuccessModalComponent } from './consultant-contact-success-modal/consultant-contact-success-modal.component';
@NgModule({
  declarations: [
    MyStoryPageComponent,
    MyStoryBannerComponent,
    ConsultantWidgetComponent,
    ConsultantFinderModalComponent,
    ConsultantFinderComponent,
    ConsultantFinderResultComponent,
    MyOpenPartiesPagesComponent,
    ConsultantFinderPageComponent,
    ConsultantLocatorPageComponent,
    ConsultantWholesaleModalComponent,
    ConsultantContactSuccessModalComponent,
  ],
  imports: [
    CommonModule,
    ConsultantRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
  ],
  exports: [
    MyStoryBannerComponent,
    ConsultantWidgetComponent,
    ConsultantFinderModalComponent,
    ConsultantWholesaleModalComponent,
  ],
})
export class ConsultantModule {}
